






































































import Vue, { PropType, VueConstructor } from "vue";
import VaButton from "@/components/atoms/VaButton.vue";
import {
  languagesOptions,
  timezonesOptions,
} from "@/services/languagesService";
import wizardStepsMixin, {
  WizardMixin,
} from "@/components/mixins/wizardStepsMixin";
import cloneDeep from "lodash/clone";
import { WizardConfiguration } from "@/models/wizardConfiguration";
import validationMixin from "@/components/mixins/validationMixin";

export default (Vue as VueConstructor<WizardMixin>).extend({
  name: "StepLanguages",
  mixins: [wizardStepsMixin, validationMixin],
  props: {
    wizardConfiguration: {
      type: Object as PropType<WizardConfiguration>,
      required: false,
    },
  },
  data() {
    return {
      language: undefined as string | undefined,
      timezone: undefined as string | undefined,
      languagesOptions: languagesOptions,
      timezoneOptione: timezonesOptions,
    };
  },
  components: { VaButton },
  computed: {},
  methods: {
    onFinish() {
      if (this.language && this.timezone) {
        const res = this.wizardConfiguration
          ? cloneDeep(this.wizardConfiguration)
          : ({} as WizardConfiguration);
        res.language = this.language;
        res.timeZone = this.timezone;
        this.$emit("onUpdateConfig", res);
        this.onNext();
      }
    },
  },
});
